module.exports = __webpack_public_path__ + "1bc9d1410e06fca246b99e5b502ea52a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Auth/assets/3-huge-discount.svg
// module id = ./app/containers/Auth/assets/3-huge-discount.svg
// module chunks = 40